import React from 'react'
import ReactDOM from 'react-dom'

export async function initializeYmaps() {
  // Ждем загрузку API и модуля reactify
  // Загружаем одновременно API, react-биндинги и пакет с контролами.
  const [ymaps3React] = await Promise.all([
    window.ymaps3.import('@yandex/ymaps3-reactify'),
    window.ymaps3.ready,
  ])

  // Создаем функцию reactify, привязанную к React
  const reactify = ymaps3React.reactify.bindTo(React, ReactDOM)

  // "Реактифицируем" основные компоненты
  const core = reactify.module(window.ymaps3)

  // "Реактифицируем" компоненты контролов из загруженного пакета
  const {
    YMapZoomControl,
    YMapGeolocationControl,
    YMapDefaultMarker,
    YMapSearchControl,
  } = await reactify.module(
    await window.ymaps3.import('@yandex/ymaps3-default-ui-theme'),
  )
  return {
    ymaps3: window.ymaps3,
    // Основные компоненты
    YMap: core.YMap,
    YMapDefaultSchemeLayer: core.YMapDefaultSchemeLayer,
    YMapDefaultFeaturesLayer: core.YMapDefaultFeaturesLayer,
    YMapMarker: core.YMapMarker,
    YMapControls: core.YMapControls,
    YMapListener: core.YMapListener,
    // Компоненты контролов
    YMapSearchControl: YMapSearchControl,
    YMapZoomControl: YMapZoomControl,
    YMapGeolocationControl: YMapGeolocationControl,
    YMapDefaultMarker: YMapDefaultMarker,
  }
}
